if (!customElements.get('variant-label')) {
  class VariantLabel extends HTMLElement {
    constructor() {
      super();
      this.variantLabels = this.querySelectorAll('.js-variant-label');
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      if (this.variantLabels) {
        // Bind to on:variant:change event for this product
        const variantPicker = this.closest('.product').querySelector('variant-picker');
        if (variantPicker) {
          variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
        }

        if (this.dataset.currentVariantId) {
          this.setVisibleVariantLabel(this.dataset.currentVariantId);
        }
      }
    }

    /**
     * Sets the visible variant variantLabels.
     * @param {string} variantId - The variant id
     */
    setVisibleVariantLabel(variantId) {
      this.variantLabels.forEach((variantLabel) => {
        variantLabel.hidden = variantLabel.dataset.variantId.toString() !== variantId.toString();
      });
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        this.setVisibleVariantLabel(evt.detail.variant.id);
      }
    }
  }

  customElements.define('variant-label', VariantLabel);
}


(() => {
  let saleLabelClone = null;

  /**
   * Calcula el % de descuento
   */
  function calculateDiscount(price, compareAtPrice) {
    if (!compareAtPrice || compareAtPrice <= price) return null;
    return Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
  }

  /**
   * Clona el label UNA SOLA VEZ
   */
  function initSaleLabelClone(product) {
    if (saleLabelClone) return saleLabelClone;

    const priceWas = product.querySelector('.price--on-sale .price__was');
    const originalLabel = product.querySelector(
      '.product-label.product-label--sale'
    );

    if (!priceWas || !originalLabel) return null;

    // 🧬 clonar
    saleLabelClone = originalLabel.cloneNode(true);
    saleLabelClone.classList.add('is-clone');
    saleLabelClone.removeAttribute('hidden');
    saleLabelClone.removeAttribute('aria-hidden');

    // 📌 insertar
    priceWas.insertAdjacentElement('afterend', saleLabelClone);

    return saleLabelClone;
  }

  /**
   * Actualiza SOLO el span del clone
   */
  function updateSaleLabelClone(product, variant) {
    const clone = initSaleLabelClone(product);
    if (!clone) return;

    const discount = calculateDiscount(
      variant.price,
      variant.compare_at_price
    );

    // ❌ sin descuento → ocultar
    if (discount === null) {
      clone.style.display = 'none';
      return;
    }

    // ✅ con descuento → mostrar y actualizar
    const span = clone.querySelector('span');
    if (span) {
      span.textContent = `-${discount} %`;
    }

    clone.style.display = '';
  }

  /**
   * EVENT HANDLER
   */
  function handleVariantChange(evt) {
    const variant = evt.detail?.variant;
    if (!variant) return;

    console.log('PRICE:', variant.price);
    console.log('COMPARE PRICE:', variant.compare_at_price);

    const product = document.querySelector('.product');
    if (!product) return;

    updateSaleLabelClone(product, variant);
  }

  /**
   * INIT DOM
   */
  document.addEventListener('DOMContentLoaded', () => {
    const product = document.querySelector('.product');
    if (!product) return;

    // 🔹 crear clone apenas carga
    initSaleLabelClone(product);

    // 🔹 disparar evento inicial si existe variant id
    const input = document.querySelector('[data-variant-id-input]');
    if (!input?.value) return;

    document.dispatchEvent(
      new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          variant: {
            id: Number(input.value)
          }
        }
      })
    );
  });

  /**
   * ESCUCHAR SIEMPRE
   */
  document.addEventListener('on:variant:change', handleVariantChange);
})();